export const translateAnimalsTypes = (t) => ({
  BIRD: t('supervisions.form.animals.BIRD'),
  EQUINE: t('supervisions.form.animals.EQUINE'),
  FARM: t('supervisions.form.animals.FARM'),
  OTHER: t('supervisions.form.animals.OTHER')
});
